import Vue from "vue";
import Router from "vue-router";
import Error404 from "@/components/errors/404";
import DirectoryLayout from "@/components/directory/Layout";
import DirectoryIndex from "@/components/directory/Index";
import DirectorySync from "@/components/directory/Sync";
import DirectorySyncRun from "@/components/directory/SyncRun";
import Settings from "@/components/Settings";
import Communication from "@/components/communication/Communication";
import CommunicationLog from "@/components/communication/CommunicationLog";
import ConnectReconnect from "@/components/ConnectReconnect";
import ConnectReturn from "@/components/ConnectReturn";
import Activity from "@/components/Activity";
import AuthLogin from "@/components/auth/Login";
import AuthLoginReturn from "@/components/auth/LoginReturn";
import WizardStepOne from "@/components/wizard/StepOne";
import WizardStepTwo from "@/components/wizard/StepTwo";
import WizardStepThree from "@/components/wizard/StepThree";
import MatchingLayout from "@/components/matching/Layout";
import MatchingIndex from "@/components/matching/Index";
import MatchingGroups from "@/components/matching/Groups";
import MatchingClasses from "@/components/matching/Classes";
import MatchingUsers from "@/components/matching/Users";
import RegionDetect from "@/components/RegionDetect";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			name: "dashboard",
			path: "/",
			component: DirectoryIndex,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			path: "/directory",
			component: DirectoryLayout,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			},
			children: [
				{
					name: "directory",
					path: "",
					component: DirectoryIndex,
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				},
				{
					name: "directory.sync",
					path: "/directory/sync",
					components: {
						default: DirectorySync
					},
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				},
				{
					name: "directory.sync.run",
					path: "/directory/sync/run/:uuid",
					components: {
						default: DirectorySyncRun
					},
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				}
			]
		},
		{
			name: "wizard",
			path: "/wizard",
			component: WizardStepOne,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: false
			}
		},
		{
			name: "wizard.settings",
			path: "/wizard/settings",
			component: WizardStepTwo,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: false
			}
		},
		{
			name: "wizard.match",
			path: "/wizard/match",
			component: WizardStepThree,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: false
			}
		},
		{
			name: "settings",
			path: "/settings",
			component: Settings,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			name: "connect.reconnect",
			path: "/reconnect",
			component: ConnectReconnect,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			name: "connect.return",
			path: "/connect/return",
			component: ConnectReturn,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			path: "/matching",
			component: MatchingLayout,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			},
			children: [
				{
					name: "matching",
					path: "",
					component: MatchingIndex,
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				},
				{
					name: "matching.groups",
					path: "/matching/groups",
					component: MatchingGroups,
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				},
				{
					name: "matching.classes",
					path: "/matching/classes",
					component: MatchingClasses,
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				},
				{
					name: "matching.users",
					path: "/matching/users",
					component: MatchingUsers,
					meta: {
						requiresAuth: true,
						requiresShard: true,
						completedWizard: true
					}
				}
			]
		},
		{
			name: "activity",
			path: "/activity",
			component: Activity,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			name: "communication",
			path: "/communication",
			component: Communication,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			name: "communication.log",
			path: "/communication/log",
			component: CommunicationLog,
			meta: {
				requiresAuth: true,
				requiresShard: true,
				completedWizard: true
			}
		},
		{
			name: "login",
			path: "/login",
			component: AuthLogin,
			meta: {
				requiresAuth: false,
				requiresShard: false,
				layout: "auth"
			}
		},
		{
			name: "login.return",
			path: "/login/return",
			component: AuthLoginReturn,
			meta: {
				requiresAuth: false,
				requiresShard: false,
				layout: "auth"
			}
		},
		{
			name: "region",
			path: "/region",
			component: RegionDetect,
			meta: {
				requiresAuth: true,
				requiresShard: false,
				layout: "auth"
			}
		},
		{
			name: "errors.404",
			path: "*",
			component: Error404,
			meta: {
				layout: "auth"
			}
		}
	]
});
